import axios from "../utils/axios";

// Upload Banner Image
export const createBannerApi = (formData) =>
  axios.post("/api/banners/upload", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

// Get Banner Image by Restaurant ID public api 
export const getBannerApi = (restaurantId) =>
  axios.get(`/api/banners/get/${restaurantId}`);

// Delete Banner Image
export const deleteBannerApi = (id) =>
  axios.delete(`/api/banners/delete/${id}`);

export const getRestaurantBannerApi = () =>
  axios.get("/api/banners/restaurant");
